import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReconnectComponent } from "./reconnect.component";
import { AsksuiteCitrusModule } from "asksuite-citrus";
import { LayoutsModule } from "src/app/layouts/layouts.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [
    ReconnectComponent
  ],
  imports: [
    CommonModule,
    LayoutsModule,
    TranslateModule,
    AsksuiteCitrusModule,
  ],
  exports: [
    ReconnectComponent,
  ],
})
export class ReconnectModule {}
